<template>
  <!--历史版本-->
  <div class="history">
    <div class="head">
      <ul class="clearfix">
        <span class="back fl" @click="backhistory"></span>
        <li>{{title}}</li>
      </ul>
    </div>
    <ul class="ulBox" v-on:scroll="historyScroll()" ref="historyBox">
      <li v-for="(item,index) in historyArr">
        <div class="list">
          <i class="iconfont" :class="item.fileName | sliceType(item.fileName, item.isDir)" style="vertical-align: super"></i>
          <div class="con">
            <div class="right">
              <h4>
                <em>{{item.versionNo}}</em>
                <i>{{item.fileName}}</i>
              </h4>
              <span>{{item.gmtModified | formaTime}}</span>
            </div>
            <div v-show="index === 0" class="new">最新</div>
            <div id="moreh" @click="hselected(index)" :class="{'more':up===index}" v-if="index!==0"></div>
            <div class="size">{{item.length | bytesToSize}}</div>
          </div>
        </div>
        <div class="select hselect" v-if="select===index">
          <ul class="clearfix" style="padding-top: 0.15rem;">
            <li @click="goBack(item.id)">
              <img src="../assets/images/newest.png" alt="">
              <p>设为最新</p>
            </li>
          </ul>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import apis from '../apis/index'
  import {MessageBox, Toast, Indicator, Popup} from 'mint-ui'
  import cloudApi from '../apis/cloudStorageApi'
  import {eventBus} from '../utils/event-bus'

  export default {
    name: 'history',
    data () {
      return {
        page: 0,
        historyArr: [],
        title: '历史版本',
        up: '',
        select: ''
      }
    },
    created () {
      this.list()
    },
    methods: {
      list: function () {
        let _this = this
        apis.request(cloudApi.getVertionLists, {fileId: _this.fileId, page: 0, size: 20}).then(function (res) {
          let data = res.data.content
          if (data.length > 0) {
            for (let i = 0; i < data.length; i++) {
              _this.historyArr.push(data[i])
            }
          }
        }).catch(function (error) {
        })
      },
      historyScroll: function () {
        let _this = this
        let ulBox = _this.$refs.historyBox
        if (ulBox.scrollTop + ulBox.clientHeight >= ulBox.scrollHeight) {
          _this.page++
          apis.request(cloudApi.getVertionLists, {
            fileId: _this.fileId,
            page: _this.page,
            size: 20
          }).then(function (res) {
            let data = res.data.content
            if (data.length > 0) {
              for (let i = 0; i < data.length; i++) {
                _this.historyArr.push(data[i])
              }
            }
          }).catch(function (error) {
            Toast({
              message: error.response.data.message,
              iconClass: 'icon-error'
            })
          })
        }
      },
      backhistory: function () {
        this.$emit('history', false)
        eventBus.$emit('initFileData')
      },
      //      历史版本下拉
      hselected: function (index) {
        if (this.select === index) {
          this.select = ''
          this.up = ''
        } else {
          this.select = index
          this.up = index
        }
      },
      goBack: function (fileId) {
        let _this = this
        apis.request(cloudApi.setNewest, {vid: fileId}).then(function (res) {
          Toast({
            message: '已设为最新',
            iconClass: 'icon-success'
          })
          _this.historyArr = []
          _this.list()
        }).catch(function (error) {
          Toast({
            message: error.response.data.message,
            iconClass: 'icon-error'
          })
        })
      }
    },
    props: ['fileId']
  }
</script>

<style scoped>
  .history {
    height: 100%;
    background-color: #fff;
  }

  .history .head {
    padding: 0 0.3rem;
  }

  .history ul {
    position: relative;
  }
  .history .right h4 {
    /*width: 80%;*/
    position: relative;
    width: fit-content;
  }
  .history .ulBox .list{
    height: .99rem;
    padding-top: .14rem;
    padding-left: .3rem;
    width: 80%;
  }
  .history .ulBox > li {
    position: relative;
    border-bottom: 1px solid #e5e5e5;
  }
  .history .right i {
    width: 2rem;
    display: inline-block;
    position: relative;
    height: 0.4rem;
    font-size: 0.28rem;
    color: #1d1f22;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-style: normal;
  }

  .history .right span {
    display: block;
  }
  /*顶部样式*/
  .head {
    font-size: 0.36rem !important;
    position: fixed;
    top: 0;
    width: 100%;
    height: 1.28rem;
    line-height: 0.88rem;
    -webkit-backdrop-filter: blur(40px);
    backdrop-filter: blur(40px);
    background-color: #E4393C;
    color: #fff;
    z-index: 999;
  }
  .head ul {
    text-align: center;
    position: relative;
    margin-top: 0.4rem;
  }
  .head ul .back{
    width: 0.2rem;
    height: 0.35rem;
    background: url("../assets/images/back-mobile.png") center no-repeat;
    background-size: 0.2rem 0.35rem;
    top: 0.26rem;
    position: absolute;
    left: 0;
  }
  .iconfont{
    font-size: 0.62rem;
  }
  /*点击下啦*/
  .select {
    height: 0.98rem;
    background-color: #f7f7fa;
  }

  .select ul {
    height: 100%;
    padding: .1rem 0;
    color: #333333;
    background-color: #f7f7f7;
    font-size: 0.2rem;
  }
  .select ul li {
    height: 100%;
    width: 100%;
    border: none;
    text-align: center;
  }
  .select ul li img {
    width: .35rem;
    height: .36rem;
  }
  #moreh {
    width: 0.2rem;
    height: 0.26rem;
    position: absolute;
    right: 0.2rem;
    top: 0.4rem;
    background: url("../assets/images/down.png") center no-repeat;
    background-size: 0.18rem 0.12rem;
  }
  .more {
    background: url("../assets/images/up.png") center no-repeat !important;
    background-size: 0.18rem 0.12rem !important;
  }
  .history .new {
    position: absolute;
    right: 1.5rem;
    top: 0.4rem;
    width: 0.8rem;
    height: 0.32rem;
    line-height: 0.32rem;
    background-color: #eaeaea;
    border-radius: 4px;
    text-align: center;
    margin-top: -0.03rem;
  }

  .history .right em {
    position: absolute;
    right: 2.1rem;
    font-weight: normal;
    font-style: initial;
    top: 0.01rem;
    color: #E4393C;
  }
  .con {
    display: inline-block;
    width: 70%;
    margin-left: .228rem;
  }
  .con .size{
    position: absolute;
    right: .64rem;
    top: .4rem;
    color: #c7c7c7;
  }
</style>



// WEBPACK FOOTER //
// src/components/history.vue